import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { initDataProp } from '../../utility/service/api-service';
import { checkDpSuccess } from '../../utility/service/tool-service';

export function Documents() {
  const { t } = useTranslation();

  const axios_downloadPdf=(linkTarget)=>{
    initDataProp({reqType:linkTarget})
      .then((res)=>{
        if(checkDpSuccess(res)){
          let resData = res?.data?.RespBody;
          let url = ''
          if(linkTarget==='privacyLink'){
            url = resData?.privacyLink;
          }else if(linkTarget==='serviceLevelLink'){
            url = resData?.serviceLevelLink;
          }else if(linkTarget==='informationSecurityLink'){
            url = resData?.informationSecurityLink;
          }else if(linkTarget==='certificationLink'){
            url = resData?.certificationLink;
          }
          let fileName = url.slice(url.lastIndexOf('/')+1);
          if(!fileName){
            fileName = `${linkTarget}.pdf`
          }
          const link = document.createElement('a');
          link.href = url;
          link.target = '_blank';  // 設定為新分頁打開
          link.textContent = fileName;  // 可選，設置顯示的文字
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);// 清除資源
        }
      })
   
  }

  return (
    <div className="documents">
      <a 
        style={{cursor:'pointer'}} 
        onClick={()=>{axios_downloadPdf('privacyLink')}}
        className='documents-link' 
        target="_blank" 
        rel="noopener noreferrer"
      >
        {t('privacy_policy')}
      </a>
      <a 
        style={{cursor:'pointer'}} 
        onClick={()=>{axios_downloadPdf('informationSecurityLink')}}
        className='documents-link' 
        target="_blank" 
        rel="noopener noreferrer"
      >
        {t('information_security')}
      </a>
      <a 
        style={{cursor:'pointer'}}
        onClick={()=>{axios_downloadPdf('serviceLevelLink')}} 
        className='documents-link' 
        target="_blank" 
        rel="noopener noreferrer"
      >
        {t('service_level')}
      </a>
      <a 
        style={{cursor:'pointer'}}
        onClick={()=>{axios_downloadPdf('certificationLink')}} 
        className='documents-link' 
        target="_blank" 
        rel="noopener noreferrer"
      >
        {t('certificationMark')}
      </a>
    </div>
  );
}
